import FormErrors from 'app/utils/form_errors'
import deserialize from 'app/utils/deserialize'
import { fetch, update } from 'app/utils/data'

export default {
  namespaced: true,

  state: {
    item: null
  },

  getters: {
    emailData: (state) => state.item,
    sendMarketing: (state) => state.item && state.item.sendMarketing,
    marketingUpdateAt: (state) => state.item && state.item.marketingUpdateAt,
    emailBounced: (state) => state.item && state.item.emailBounced,
    emailBouncedAt: (state) => state.item && state.item.emailBouncedAt
  },

  mutations: {
    emailDataFetched(state, { emailData }) {
      state.item = emailData
    },
    resetState(state) {
      state.item = null
    }
  },

  actions: {
    async fetchEmailData({ commit }) {
      try {
        const response = await fetch({
          url: '/api/email',
          type: 'email_data'
        })

        const emailData = await deserialize(response.data)
        commit('emailDataFetched', { emailData })
        return emailData
      } catch (error) {
        throw new FormErrors(error.response?.data?.errors || [])
      }
    },

    async updateEmailData({ commit, state }, changes) {
      try {
        const response = await update({
          url: '/api/email',
          patch: true,
          type: 'email_data',
          changes,
          record: state.item
        })

        const updatedEmailData = await deserialize(response.data)
        commit('emailDataFetched', { emailData: updatedEmailData })
        return updatedEmailData
      } catch (error) {
        throw new FormErrors(error.response?.data?.errors || [])
      }
    }
  }
}
